export class DateUtil {

  static getDateOnlyFormat(dateString: string | Date): string {
    try {
      if (!dateString) return "";
      const date = new Date(dateString);
      if (Number.isNaN(date.getTime())) return "";
      return date.toISOString().split('T')[0];
    } catch {
      return dateString.toString() || "";
    }
  }

  static beautifulDateFormat(dateString: string): string {
    if (!dateString) return 'Not specified';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-IN', {
        weekday: 'short',
        month:   'short',
        day:     'numeric',
        year:    'numeric',
      });
    } catch (error) {
      console.error('Error formatting date:', error, dateString);
      return dateString;
    }
  }

  static formatDateForType(dateString: string, format: string): string {
    if (!dateString) return 'Not specified';
    try {
      const date = new Date(dateString);

      if (dateString.length === 8 && /^\d{2}:\d{2}:\d{2}$/.test(dateString)) {
        const [hours, minutes, seconds] = dateString.split(':').map(Number);
        date.setUTCFullYear(1970, 0, 1);
        date.setUTCHours(hours, minutes, seconds, 0);
      }

      if (Number.isNaN(date.getTime())) {
        console.warn('Invalid date string:', dateString);
        return dateString;
      }

      switch (format) {
        case 'date-only':
          // en-IN gives DD/MM/YYYY — correct for India
          return date.toLocaleDateString('en-IN', {
            day:   '2-digit',
            month: '2-digit',
            year:  'numeric',
          });

        case 'beautiful-date-time':
          return date.toLocaleDateString('en-IN', {
            month:  'short',
            day:    'numeric',
            year:   'numeric',
            hour:   '2-digit',
            minute: '2-digit',
            hour12: true,
          });

        case 'beautiful':
          return this.beautifulDateFormat(dateString);

        case 'locale':
          return date.toLocaleDateString('en-IN');

        case 'iso':
          return date.toISOString();

        case 'time-only':
          return date.toLocaleString('en-IN', {
            hour:   '2-digit',
            minute: '2-digit',
            hour12: true,
          }).replace(',', '');

        case 'date-time':
          return date.toLocaleString('en-IN', {
            day:    '2-digit',
            month:  '2-digit',
            year:   'numeric',
            hour:   '2-digit',
            minute: '2-digit',
            hour12: true,
          }).replace(',', '');

        default:
          return dateString;
      }
    } catch (error) {
      console.error('Error formatting date:', error, dateString);
      return dateString;
    }
  }
}